import type { OnInit } from '@angular/core';

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-vx-check',
  imports: [RouterModule],
  templateUrl: './vx-check.component.html',
  styleUrl: './vx-check.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class VxCheckComponent implements OnInit {
  isWX = false;

  ngOnInit(): void {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/micromessenger/i.test(userAgent)) {
      this.isWX = true;
    }
  }
}
